// ALTIERO chrome: what the theme's Liquid chrome does once it is on the page. The announcement bar, header and footer
// are the header and footer groups' sections; the bag, look sheet, card sheet and search panels are snippets the layout
// prints, and the phone menu is the header's. This file opens and closes the panels, fills the bag and the look sheet,
// searches, keeps the bag count and the bar's free-shipping meter, marks the current page's link and handles the sign-up
// forms. It loads right after ui.js and adds UI.add, openCart, openLook, openSearch, openPanel, closePanel, toast,
// announce and markNav for the page scripts.
// Prices, stock and the cart live in store.js. This file only draws them; never re-implement pricing here.
// The prototype keeps its own copy (assets/js/chrome.js, which draws the chrome itself), frozen with it.
(function () {
  'use strict';
  var S = window.Store, U = window.UI, K = U._chrome;
  var T = S.DATA.freeShippingThreshold;
  // ui.js's settings and helpers (UI._chrome there), and its public ones
  var $ = K.$, $$ = K.$$, reduce = K.reduce, SITE = K.SITE, CARD_PCT = K.CARD_PCT, cat = K.cat, get = K.get, SHOPIFY = K.SHOPIFY;
  var COPY = U.copy, esc = U.esc, money = U.money, num = U.num, icon = U.icon, CATS = U.CATS, SHOP_CATS = U.SHOP_CATS,
    LOOKS = U.LOOKS, productUrl = U.productUrl, shopUrl = U.shopUrl, aboutUrl = U.aboutUrl, pageCat = U.pageCat,
    pageHandle = U.pageHandle, inStock = U.inStock, fromPrice = U.fromPrice, lastSize = U.lastSize, defaultSize = U.defaultSize,
    thumb = U.thumb, swatch = U.swatch, sizeChips = U.sizeChips;
  // a line with its [brackets] filled in, as plain text (esc it for HTML); line: the words, when not COPY[k]
  var fill = function (k, vals, line) { return Object.keys(vals).reduce(function (t, b) { return t.split('[' + b + ']').join(vals[b]); }, line || COPY[k]); };

  // ---------- the current page's link ----------
  function navKey() {
    var page = document.body.getAttribute('data-page');
    if (page === 'about') return ['about', 'page'];
    if (page === 'shop') return [pageCat(), 'page'];
    // a product page with no or an unknown handle shows the Noir leather jacket (product.js), so mark Jackets
    if (page === 'product') { var p = S.byHandle(pageHandle()) || S.byHandle('altieros-matte-black-leather-jacket'); return p ? [p.category, 'true'] : []; }
    return [];
  }
  // Marks the current page in the header nav and the phone menu. Runs on load and on popstate; call UI.markNav() after
  // pushState. The built-in links (snippets/nav-links) mark the page's category or About; a store menu (data-menu) marks
  // the link to this address (or to this path, when the link has no query).
  function markNav() {
    var k = navKey(), here = location.pathname + location.search, want = k[0] === 'about' ? aboutUrl : k[0] ? shopUrl(k[0]) : null;
    $$('.nav a, .menu-nav a').forEach(function (a) {
      var href = a.getAttribute('href'), menu = a.closest('[data-menu]');
      if (menu ? href === here || href === location.pathname : href === want) a.setAttribute('aria-current', menu ? 'page' : k[1]); else a.removeAttribute('aria-current');
    });
  }

  // ---------- panels: native modal <dialog> ----------
  // One panel at a time. Esc and the backdrop close it, Tab is kept inside, focus goes back to the control that opened it.
  var current = null, opener = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var visible = function (el) { return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; };
  function wire(d) {
    if (d.__wired) return; d.__wired = true;
    d.addEventListener('cancel', function (e) { e.preventDefault(); closePanel(); });
    d.addEventListener('close', function () { if (current === d) { current = null; giveBack(); } });
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-close]')) closePanel(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }   // also beats a search field's own Esc
      if (e.key !== 'Tab') return;
      var f = $$(FOCUSABLE, d).filter(visible); if (!f.length) return;
      var a = document.activeElement, first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (a === first || f.indexOf(a) < 0)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    });
  }
  function hide(d) { d.classList.remove('is-closing'); if (d.open) d.close(); }
  function giveBack() { var o = opener; opener = null; if (o && o.isConnected && visible(o)) o.focus(); }
  function openPanel(d, from) {
    wire(d);
    var f = from || document.activeElement;
    if (f && f !== document.body && !f.closest('dialog')) opener = f;   // remember the control outside any panel
    if (current && current !== d) hide(current);
    if (!d.open) { d.classList.remove('is-closing'); d.showModal(); }
    current = d;
    var target = $('[data-autofocus]', d) || $('.panel-title[tabindex]', d) || $(FOCUSABLE, d);
    if (target) target.focus({ preventScroll: true });
  }
  function closePanel(instant) {
    var d = current; if (!d) return;
    current = null;
    var done = function () { hide(d); if (!current) giveBack(); };
    if (instant || reduce()) done(); else { d.classList.add('is-closing'); setTimeout(done, 190); }
  }

  // ---------- the welcome code: shown once the shopper joins the list, added at checkout ----------
  // the code and its percent are Theme settings > Discounts (ALTO5, 5% off the whole order: not first-order only)
  var WELCOME = String(SITE.signupCode || '').replace(/[^\w-]/g, '') || 'ALTO5', WELCOME_PCT = +SITE.signupPercent || 5, JOIN_KEY = 'altiero-joined';
  function joined(set) {
    if (set) S.setCode(WELCOME_PCT);   // checkout adds the code, so the bag judges free shipping after it (store.js)
    try { if (set) localStorage.setItem(JOIN_KEY, '1'); return localStorage.getItem(JOIN_KEY) === '1'; } catch (e) { return !!set; }
  }
  if (joined() || SHOPIFY && /[?&]customer_posted=true/.test(location.search)) S.setCode(WELCOME_PCT);
  function signupDone(f) {
    // the form's own words (blocks/email-signup: data-done, data-code), else ui.js's; the code in bold
    f.innerHTML = '<p class="signup-done"><b>' + esc(f.dataset.done || COPY.signup_done) + '</b> ' +
      esc(fill('signup_code', { percent: WELCOME_PCT }, f.dataset.code)).split('[code]').join('<b>' + WELCOME + '</b>') + '</p>';
  }

  // ---------- toasts and announcements ----------
  function announce(msg) {
    var el = (current && $('[data-live]', current)) || $('#uiLive');
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 60);
  }
  function toast(msg, isError) {
    var box = $('.toasts');
    if (!box) { box = document.createElement('div'); box.className = 'toasts'; box.setAttribute('role', 'status'); }
    var host = current || document.body; if (box.parentNode !== host) host.appendChild(box);
    var t = document.createElement('p'); t.className = 'toast' + (isError ? ' is-error' : ''); t.textContent = msg;
    box.appendChild(t);
    setTimeout(function () { t.classList.add('is-leaving'); setTimeout(function () { t.remove(); }, 260); }, 4500);
  }

  // ---------- the bar's free-shipping meter and the bag count ----------
  // Liquid prints both for an empty bag (blocks/_ship-meter, sections/header); an emptied bag gets that back. Phones show
  // the meter alone once the bag has items (site.css, .has-bag).
  function renderChrome() {
    var q = S.cart.pricing(), n = q.count, c = $('#bagCount'), btn = $('#bagBtn'), bar = $('#trustbar'), ship = $('[data-ship]');
    if (c) { c.hidden = !n; c.textContent = n; }
    if (btn) { btn.__empty = btn.__empty || btn.getAttribute('aria-label'); btn.setAttribute('aria-label', n ? 'Bag, ' + n + (n === 1 ? ' item' : ' items') : btn.__empty); }
    if (bar) bar.classList.toggle('has-bag', !!n);
    if (!ship) return;
    ship.__empty = ship.__empty || ship.innerHTML;
    ship.innerHTML = !n ? ship.__empty
      : q.freeShipping ? '<b>' + esc(COPY.ship_unlocked) + '</b> on your bag'
      : '<i class="meter" style="--p:' + q.progress.toFixed(3) + '"><i></i></i><b>' + money(Math.max(1, q.toFreeShipping)) + '</b> ' + esc(COPY.to_free);
  }

  // ---------- cart drawer ----------
  var cartEl, lookEl, searchEl, checkoutOpen = false;
  function outfitHTML(q) {
    var miss = q.missingCategories, nouns = miss.map(function (c) { return cat(c).noun; });
    // a styling nudge only: the store gives no outfit saving
    var msg = miss.length ? COPY.outfit_missing.split('[pieces]').join(nouns.join(' or ')) : COPY.outfit_done;
    return '<div class="outfit"><ol class="outfit-slots" aria-label="Your outfit">' + CATS.map(function (c) {
      var on = miss.indexOf(c.id) < 0;
      return '<li' + (on ? ' class="on"' : '') + '>' + (on ? icon('check') : '') + c.slot + '<span class="vh">' + (on ? ', in your bag' : ', not yet') + '</span></li>';
    }).join('') + '</ol><p class="outfit-msg">' + msg + '</p></div>';
  }
  function shipHTML(q) {
    return '<div class="cart-ship"><div class="progress" role="progressbar" aria-label="Progress to free shipping" aria-valuemin="0" aria-valuemax="' + T +
      '" aria-valuenow="' + Math.round(q.progress * T) + '" style="--p:' + q.progress.toFixed(3) + '"><i></i></div>' +
      '<p>' + (q.freeShipping ? '<b>' + esc(COPY.ship_unlocked) + '.</b>' : '<b>' + money(Math.max(1, q.toFreeShipping)) + '</b> ' + esc(COPY.to_free)) + '</p>' +
      ((CARD_PCT || !q.freeShipping) && COPY.card_delivery ?'<p class="t-small muted">' + esc(COPY.card_delivery) + '</p>' : '') + '</div>';
  }
  function lineHTML(l) {
    var p = l.product, id = p.handle + '-' + l.size, who = esc(p.name) + ' - ' + esc(p.colour) + ', ' + l.size, at = ' data-h="' + p.handle + '" data-s="' + l.size + '"';
    return '<li class="cart-line">' + thumb(p, { href: productUrl(p.handle) }) + '<div class="line-main">' +
      '<div class="line-top"><p class="line-name"><a href="' + productUrl(p.handle) + '">' + esc(p.name) + '</a></p><p class="price">' + money(l.price * l.qty) + '</p></div>' +
      '<p class="line-meta">' + esc(fill('cart_line', { colour: p.colour, size: l.size })) + (l.qty > 1 ? ', ' + esc(fill('cart_each', { price: money(l.price) })) : '') + '</p>' +
      '<div class="line-ctrl"><div class="qty" role="group" aria-label="Quantity of ' + who + '">' +
        '<button type="button" data-qty="' + (l.qty - 1) + '"' + at + ' data-k="dec-' + id + '" aria-label="One less"' + (l.qty <= 1 ? ' disabled' : '') + '>' + icon('minus') + '</button>' +
        '<output aria-label="Quantity">' + l.qty + '</output>' +
        '<button type="button" data-qty="' + (l.qty + 1) + '"' + at + ' data-k="inc-' + id + '" aria-label="One more"' + (l.qty >= 10 ? ' disabled' : '') + '>' + icon('plus') + '</button></div>' +
        '<button class="link line-remove" type="button" data-remove' + at + ' data-k="rm-' + id + '">' + esc(COPY.cart_remove) + '<span class="vh"> ' + who + '</span></button></div></div></li>';
  }
  // list/title: the empty bag's own picks (jackets); without them, the suggestions for what is in the bag
  function addonsHTML(list, title) {
    list = list || S.suggestions();
    if (!list.length) return '';
    var id = title ? 'picksTitle' : 'addonsTitle';
    return '<section class="addons" aria-labelledby="' + id + '"><h3 class="panel-sub" id="' + id + '">' + esc(title || COPY.bag_addons) + '</h3><ul>' + list.map(function (p) {
      var note = S.stockNote(p);
      return '<li class="addon">' + thumb(p, { href: productUrl(p.handle) }) + '<div class="addon-main">' +
        '<p class="addon-name"><a href="' + productUrl(p.handle) + '">' + esc(p.name) + '</a> <span>' + esc(p.colour) + '</span></p>' +
        '<p class="addon-meta"><span class="price">' + money(p.price) + '</span>' + (note ? '<span class="stock">' + note + '</span>' : '') + '</p>' +
        '<div class="sizes" role="group" aria-label="Add ' + esc(p.name) + ' - ' + esc(p.colour) + '"><span class="hint" aria-hidden="true">' + esc(COPY.cart_add_in) + '</span>' + sizeChips(p, { quick: true, small: true }) + '</div></div></li>';
    }).join('') + '</ul></section>';
  }
  function totalsHTML(q) {
    return '<dl class="totals"><div><dt>' + esc(COPY.cart_subtotal) + '</dt><dd>' + money(q.subtotal) + '</dd></div>' +
      '<div class="ship-row"><dt>' + esc(COPY.cart_shipping) + '</dt><dd>' + esc(q.freeShipping ? COPY.cart_shipping_free : COPY.cart_shipping_later) + '</dd></div>' +
      '<div class="total"><dt>' + esc(COPY.cart_total) + '</dt><dd>' + money(q.total) + '</dd></div></dl>';
  }
  function actionsHTML(q) {
    // the card discount (Theme settings > Discounts > Card payment, percent off, from the Scala Discounts app) has its own
    // button: the store's checkout can't see how the shopper will pay, so the shopper says so here
    var card = SHOPIFY && CARD_PCT;
    return '<div class="cart-actions">' +
      (card ? '<button class="btn btn-pay btn-block btn-split" type="button" data-checkout data-card data-k="checkout-card"><span class="pay-l">' + icon('card') + esc(COPY.pay_card) + '</span><span class="p">' + esc(fill('cart_card_extra', { percent: CARD_PCT })) + '</span></button>' : '') +
      '<button class="btn ' + (card ? 'btn-secondary' : 'btn-primary') + ' btn-block btn-split" type="button" data-checkout data-k="checkout" aria-expanded="' + checkoutOpen + '" aria-controls="checkoutNote"><span>' + esc(card ? COPY.pay_cod : COPY.checkout) + '</span><span class="p">' + money(q.total) + '</span></button>' +
      '<p class="checkout-note" id="checkoutNote"' + (checkoutOpen ? '' : ' hidden') + '>The live store continues to Shopify checkout: cash on delivery.</p>' +
      (joined() ? '<p class="checkout-note">' + esc(fill('cart_code', { code: WELCOME, percent: WELCOME_PCT })) + '</p>' : '') + '</div>' +
      '<ul class="trustline"><li>' + icon('cash') + esc(COPY.cod) + '</li><li>' + icon('eye') + esc(COPY.inspect) + '</li>' +
      '<li>' + icon('truck') + esc(COPY.delivery) + '</li><li>' + icon('exchange') + esc(COPY.exchanges) + '</li></ul>';
  }
  function emptyHTML() {
    var jackets = S.inCategory('jackets').filter(function (p) { return inStock(p).length; }).slice(0, 4);
    return '<div class="cart-empty"><p class="t-title">' + esc(COPY.bag_empty_title) + '</p><p>' + esc(COPY.bag_empty_text) + '</p>' +
      addonsHTML(jackets, COPY.bag_empty_picks) +
      '<h3 class="panel-sub cart-empty-sub">' + esc(COPY.bag_looks) + '</h3>' +
      '<ul class="look-links">' + LOOKS.map(function (L) {
        var q = S.price(L.handles.map(function (h) { return { handle: h, qty: 1 }; }));
        return '<li><button class="look-link" type="button" data-open-look="' + L.handles.join(',') + '" data-look-title="' + esc(L.name) + '">' +
          '<span class="cloths">' + L.handles.map(swatch).join('') + '</span><span class="nm">' + esc(L.name) + '<span>' + esc(L.pieces) + '</span></span>' +
          '<span class="price">' + money(q.total) + '</span></button></li>';
      }).join('') + '</ul><a class="btn btn-secondary btn-block" href="' + shopUrl('all') + '">' + esc(COPY.bag_shop_all) + '</a></div>';
  }
  function refocus(k, root, fallback) {
    if (!k) return;
    var keys = [k, /^dec-/.test(k) ? k.replace('dec-', 'inc-') : k.replace('inc-', 'dec-')];
    for (var i = 0; i < keys.length; i++) { var el = $('[data-k="' + keys[i] + '"]', root); if (el && !el.disabled && visible(el)) { el.focus(); return; } }
    if (fallback) fallback.focus();
  }
  function renderCart() {
    var q = S.cart.pricing(), body = $('#cartBody'), foot = $('#cartFoot');
    var a = document.activeElement, k = a && cartEl.contains(a) && a.getAttribute('data-k');
    $('#cartCount').textContent = q.count ? '(' + q.count + ')' : '';
    if (!q.count) { checkoutOpen = false; body.innerHTML = emptyHTML(); foot.hidden = true; foot.innerHTML = ''; }
    else {
      body.innerHTML = outfitHTML(q) + shipHTML(q) + '<ul class="cart-lines">' + q.items.map(lineHTML).join('') + '</ul>' + addonsHTML();
      foot.hidden = false; foot.innerHTML = totalsHTML(q) + actionsHTML(q);
    }
    refocus(k, cartEl, $('#cartTitle'));
  }
  function openCart(from) { renderCart(); openPanel(cartEl, from); }

  // ---------- look sheet ----------
  var look = null;
  // handles: product handles (or products). o: { title, sizes: { handle: size }, from }
  function openLook(handles, o) {
    o = o || {};
    var items = handles.map(get).filter(Boolean), sizes = {};
    items.forEach(function (p) { sizes[p.handle] = defaultSize(p, o.sizes && o.sizes[p.handle]); });
    look = { items: items, sizes: sizes, title: o.title || COPY.look_sheet_title };
    renderLook();
    openPanel(lookEl, o.from);
  }
  function lookLines() {
    return look.items.filter(function (p) { return look.sizes[p.handle]; }).map(function (p) { return { handle: p.handle, size: look.sizes[p.handle], qty: 1 }; });
  }
  function renderLook() {
    var a = document.activeElement, keep = a && lookEl.contains(a) && a.dataset.pick && '[data-pick="' + a.dataset.pick + '"][data-size="' + a.dataset.size + '"]';
    var L = lookLines(), q = S.price(L), n = L.length;
    $("#lookSheetTitle").textContent = look.title;
    $('#lookBody').innerHTML = '<p class="look-intro">' + esc(COPY.look_sheet_intro) + '</p>' +
      '<ul class="pieces-list">' + look.items.map(function (p) {
        var note = S.stockNote(p), open = inStock(p).length;
        return '<li class="piece-row' + (open ? '' : ' piece-out') + '">' + thumb(p) + '<div class="addon-main">' +
          '<p class="line-name">' + esc(p.name) + '</p><p class="line-meta">' + esc(p.colour) + (p.faux ? ', ' + esc(COPY.card_faux) : '') + '. <span class="price">' + money(p.price) + '</span></p>' +
          (note ? '<p class="stock">' + note + '</p>' : '') +
          (open ? '<div class="sizes" role="group" aria-label="Size for ' + esc(p.name) + ' - ' + esc(p.colour) + '">' + sizeChips(p, { selected: look.sizes[p.handle], name: p.handle }) + '</div>' : '') +
          '</div></li>';
      }).join('') + '</ul>';
    $('#lookFoot').innerHTML = '<div class="look-sum"><p><span class="t-hero">' + num(q.total) + '</span><span class="cur">EGP</span></p></div>' +
      '<p class="look-math">' + (q.freeShipping ? esc(COPY.ships_free) : money(Math.max(1, q.toFreeShipping)) + ' ' + esc(COPY.to_free) + '.') + '</p>' +
      '<button class="btn btn-primary btn-block btn-split" type="button" data-add-look style="margin-top:14px"' + (n ? '' : ' disabled') + '><span>' + esc(n > 1 ? COPY.look_add : COPY.look_add_one) + '</span><span class="p">' + money(q.total) + '</span></button>' +
      '<p class="panel-status" id="lookStatus" role="status"></p>';
    if (keep) { var el = $(keep, lookEl); if (el) el.focus(); }
  }
  function addLook() {
    var L = lookLines();
    hide(lookEl); current = null;                       // the cart takes over; focus later returns to the original opener
    try { L.forEach(function (l) { S.cart.add(l.handle, l.size, 1); }); }
    catch (e) { toast(COPY.toast_look_sold_out, true); }
  }

  // ---------- search ----------
  var COLOUR_WORDS = { 'Noir': 'black', 'Black': 'noir', 'Ecru': 'white cream off-white', 'Grey': 'gray', 'Navy': 'blue', 'Blue': 'cobalt navy',
    'Deep Maroon': 'burgundy red brown', 'Taupe': 'beige brown cropped', 'Eclipse': 'brown black dark', 'Graphite': 'grey gray charcoal' };
  var CAT_WORDS = { jackets: 'jacket jackets outerwear coat', pants: 'pants trousers tailored', knitwear: 'knit knitwear polo crewneck sweater tee top' };
  var hay = function (p) { return [p.name, p.colour, COLOUR_WORDS[p.colour], CAT_WORDS[p.category] || p.category + ' ' + (p.catLabel || ''), p.type, (p.tags || []).join(' '), p.faux ? 'faux leather' : '', p.details.join(' ')].join(' ').toLowerCase(); };
  function findProducts(qs) {
    var words = qs.toLowerCase().trim().split(/\s+/).filter(Boolean);
    return !words.length ? S.products : S.products.filter(function (p) { var h = hay(p); return words.every(function (w) { return h.indexOf(w) > -1; }); });
  }
  var lastCount = -1;
  function renderSearch() {
    var v = $('#searchInput').value.trim(), list = findProducts(v);
    $('#searchOut').innerHTML = (v ? '' : '<div class="search-cats">' + SHOP_CATS.map(function (c) {
        var lo = fromPrice(c.id);
        return '<a class="chip" href="' + shopUrl(c.id) + '">' + esc(c.label) + (lo != null ? ' <span class="muted">' + esc(fill('from_price', { price: money(lo) })) + '</span>' : '') + '</a>';
      }).join('') + '</div>') +
      (list.length ? '<ul class="results">' + list.map(function (p) {
        var note = S.stockNote(p);
        return '<li><a class="result" href="' + productUrl(p.handle) + '">' + thumb(p) + '<span><span class="result-nm">' + esc(p.name) + ' <span>' + esc(p.colour) + '</span></span><br>' +
          '<span class="price">' + money(p.price) + '</span>' + (note ? ' <span class="stock">' + note + '</span>' : '') + '</span></a></li>';
      }).join('') + '</ul>' : '<p class="search-none">' + esc(COPY.search_none).split('[search]').join(esc(v)) + '</p>');
    if (v && list.length !== lastCount) announce(list.length ? list.length + (list.length === 1 ? ' result' : ' results') : 'No results');
    lastCount = v ? list.length : -1;
  }
  function openSearch(from) { renderSearch(); openPanel(searchEl, from); }

  // ---------- the panels (the layout prints them; the phone menu is the header's, looked up when it opens) ----------
  cartEl = $('#cart'); lookEl = $('#look'); searchEl = $('#search');
  markNav();
  addEventListener('popstate', markNav);
  renderChrome();

  // header turns solid once the page scrolls (overlay pages start transparent over their hero)
  var overlay = document.body.getAttribute('data-header') === 'overlay';
  function solid() { var head = $('#siteHeader'); if (head && overlay) head.classList.toggle('is-solid', scrollY > 4); }
  if (overlay) { addEventListener('scroll', solid, { passive: true }); solid(); }

  // The theme editor swaps a changed section's HTML: a redrawn bar or header gets the bag's state, the current page's
  // mark and its scroll state again. Nothing reloads the page.
  document.addEventListener('shopify:section:load', function () { renderChrome(); markNav(); solid(); });
  // a bar line picked in the editor shows even where phones hide it (site.css, .is-picked)
  document.addEventListener('shopify:block:select', function (e) { if (e.target.parentNode === $('#trustbar')) e.target.classList.add('is-picked'); });
  document.addEventListener('shopify:block:deselect', function (e) { if (e.target.classList) e.target.classList.remove('is-picked'); });

  // ---------- adding to the bag ----------
  var pendingFrom = null;
  function add(handle, size, qty, from) {
    pendingFrom = from || null;
    try { S.cart.add(handle, size, qty || 1); return true; }
    catch (e) { pendingFrom = null; toast(COPY.toast_sold_out, true); return false; }
  }
  function describe(changes) {
    var q = S.cart.pricing(), adds = changes.filter(function (c) { return c.type === 'add'; }), last = changes[changes.length - 1];
    var label = function (c) { var p = S.byHandle(c.handle); return p.name + ' - ' + p.colour + ', size ' + c.size; };
    var msg = adds.length ? 'Added ' + adds.map(label).join('; ') + '.'
      : last.type === 'clear' ? 'Bag cleared.' : last.type === 'reset' ? 'Bag updated.' : last.qty ? label(last) + ': quantity ' + last.qty + '.' : 'Removed ' + label(last) + '.';
    return msg + (q.count ? ' Bag total ' + money(q.total) + '. ' +
      (q.freeShipping ? 'Free shipping.' : money(Math.max(1, q.toFreeShipping)) + ' to free shipping.') : ' Your bag is empty.');
  }
  // Every add opens the drawer. Adds in the same tick (a whole look) are announced and opened once.
  var queue = [], queued = 0;
  addEventListener('cart:change', function (e) {
    var c = e.detail.change;
    if (c.type === 'add') lastSize(c.size);
    queue.push(c);
    if (!queued) queued = setTimeout(function () {
      queued = 0;
      var changes = queue.splice(0), added = changes.some(function (x) { return x.type === 'add'; });
      renderChrome();
      if (added && !cartEl.open) openCart(pendingFrom); else if (cartEl.open) renderCart();
      pendingFrom = null;
      if (added) { var n = $('#bagCount'); if (n) { n.classList.remove('bump'); void n.offsetWidth; n.classList.add('bump'); } }
      announce(describe(changes));
    }, 0);
  });
  // a page restored from the back/forward cache holds a stale cart; reload if another page changed it. Back from
  // checkout, the Checkout button (disabled on the way out) works again.
  addEventListener('pageshow', function (e) {
    if (e.persisted) $$('[data-checkout]').forEach(function (b) { b.disabled = false; });
    try { if (e.persisted && localStorage.getItem('altiero-cart') !== JSON.stringify(S.cart.lines())) location.reload(); } catch (err) {}
  });

  // ---------- events ----------
  function setQuick(q, open, focus) {
    q.classList.toggle('is-open', open);
    q.querySelector('.pcard-plus').setAttribute('aria-expanded', open);
    if (open && focus) { var b = $('.size:not(:disabled)', q); if (b) b.focus(); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    var plus = t && t.classList.contains('pcard-plus') ? t : null;
    $$('.pcard-quick.is-open').forEach(function (q) { if (!plus || q !== plus.parentNode) setQuick(q, false); });
    if (!t) return;
    if (plus) { setQuick(plus.parentNode, !plus.parentNode.classList.contains('is-open'), true); return; }
    if (t.hasAttribute('data-quick')) { var qk = t.closest('.pcard-quick'); add(t.dataset.quick, t.dataset.size, 1, qk ? $('.pcard-plus', qk) : t); return; }
    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); openCart(t); return; }
    if (t.hasAttribute('data-open-search')) { openSearch(t); return; }
    if (t.hasAttribute('data-open-menu')) { openPanel($('#menu'), t); return; }
    if (t.hasAttribute('data-open-card')) { openPanel($('#cardSheet'), t); return; }
    if (t.hasAttribute('data-open-look')) { e.preventDefault(); openLook(t.getAttribute('data-open-look').split(','), { from: t, title: t.getAttribute('data-look-title') }); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || current) return;
    $$('.pcard-quick.is-open').forEach(function (q) { setQuick(q, false); $('.pcard-plus', q).focus(); });
  });
  cartEl.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-qty')) S.cart.setQty(b.dataset.h, b.dataset.s, +b.dataset.qty);
    else if (b.hasAttribute('data-remove')) S.cart.remove(b.dataset.h, b.dataset.s);
    else if (b.hasAttribute('data-checkout')) {
      if (SHOPIFY) { b.disabled = true; window.THEME.checkout(joined() ? WELCOME : null, b.hasAttribute('data-card')); return; }
      checkoutOpen = !checkoutOpen;
      b.setAttribute('aria-expanded', checkoutOpen); $('#checkoutNote').hidden = !checkoutOpen;
    }
  });
  lookEl.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-pick') && !b.disabled) { look.sizes[b.dataset.pick] = b.dataset.size; lastSize(b.dataset.size); renderLook(); }
    else if (b.hasAttribute('data-add-look')) addLook();
  });
  $('#searchInput').addEventListener('input', renderSearch);
  $('#searchForm').addEventListener('submit', function (e) {
    e.preventDefault();
    var hit = findProducts($('#searchInput').value)[0];
    if (hit && $('#searchInput').value.trim()) location.href = productUrl(hit.handle);
  });
  // every sign-up form (<form data-signup> with an email input and a .field-error): the sign-up band's (blocks/email-signup,
  // a Liquid customer form) and the homepage's. A valid one posts to Shopify, which saves a subscribed customer and comes
  // back with ?customer_posted=true; the form then shows the welcome code, and checkout adds it (the bag's checkout button).
  // ponytail: Shopify's own form errors (a failed bot check, say) aren't shown; the shopper just sees the form again.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.hasAttribute('data-signup')) return;
    var input = $('input[type="email"]', f), err = $('.field-error', f), ok = input.value.trim() && input.checkValidity();
    input.setAttribute('aria-invalid', String(!ok)); err.hidden = !!ok;
    if (!ok) { e.preventDefault(); err.textContent = f.dataset.error || COPY.signup_error; input.focus(); }
  });
  var posted = /[?&]customer_posted=true/.test(location.search);
  if (posted) joined(true);
  $$('form[data-signup]').forEach(function (f) {
    f.noValidate = true;   // the check above speaks instead of the browser's bubble
    if (joined()) { signupDone(f); return; }
    if ($('input[name="form_type"]', f)) return;   // already a Shopify customer form
    // a form written as plain HTML (the homepage's) becomes one
    f.action = '/contact#' + f.id; f.method = 'post';
    f.insertAdjacentHTML('afterbegin', '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="newsletter">');
    $('input[type="email"]', f).name = 'contact[email]';
  });
  if (posted) {
    announce('You’re on the list. Your code is ' + WELCOME + '.');
    try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) {}
  }
  Object.assign(U, {
    add: add, openCart: openCart, openLook: openLook, openSearch: openSearch, openPanel: openPanel, closePanel: closePanel, toast: toast, announce: announce,
    markNav: markNav
  });
})();
